<script setup>
import { ref, reactive, computed, onMounted, defineComponent } from 'vue'
import { useRoute, useRouter, RouterLink, RouterView } from 'vue-router'
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, GetProductsListAPI, GetActivityInfoAPI } from '@/util/api'
import meunMobile from './components/meunMobile.vue'

const route = useRoute()
const router = useRouter()
const userStore = userInfoStore()
const rewardStore = rewardListStore()

const isPC = ref(false)
const cursorActive = ref(false)

if (window.isPC) {
  isPC.value = window.isPC
  router.push('/')
} else {
  router.push('/m')
}

const getProductsList = () => {
  let reqData = {}
  GetProductsListAPI(getReqData(reqData)).then((res) => {
    console.log('【res】', res.data);
    
  }).catch(err => {
    console.log('[error]', err);
    
  })
}
const getActivityInfo = () => {
  let reqData = {}
  GetActivityInfoAPI(getReqData(reqData)).then((res) => {
    if (res.data.code == 0) {
      userStore.setuserInfo(res.data.data)
    } else {
      alert(res.data.msg)
    }
  }).catch(err => {
    console.log('[error]', err);
    
  })
}

onMounted(() =>{
  console.log('【route】', route.meta);
  
  if (isPC.value) {
    // const cursorElement = document.getElementsByClassName('mouse')[0]
    // document.addEventListener('mousemove', function(event) {
    //   cursorElement.style.left = event.clientX + 'px'
    //   cursorElement.style.top = event.clientY + 'px'
    // })

    // const navElement = document.getElementsByClassName('nav-box')[0]
    // navElement.addEventListener('mouseover', function(event) {
    //   // 处理鼠标移入的逻辑
    //   cursorActive.value = true
    //   console.log('【鼠标移入】');
      
    // });
    
    // // 监听鼠标移出事件
    // navElement.addEventListener('mouseout', function(event) {
    //   // 处理鼠标移出的逻辑
    //   cursorActive.value = false
    // });
  }
  // getProductsList()
  // getActivityInfo()
  // localStorage.setItem('appointment', '1632650064@qq.com')
})
</script>

<template>
  <section class="app-content">
    <!-- <section v-if="isPC" :class="cursorActive ? 'mouseact' : 'mouse'">
      <img v-if="cursorActive" src="./assets/j-a.png" alt="" style="width: 36px; position: absolute; top: -14px; left: -12px;">
      <img v-else src="./assets/j.png" alt="" style="width: 32px; position: absolute; top: -14px; left: -12px;">
    </section> -->
    <meunMobile v-if="!isPC && route.meta.showNav" />
    <RouterView />
  </section>
</template>

<style scoped>
.app-content {
  /* background: #000000; */
  width: 100%;
  height: 100%;
}
</style>
<style>
.mouse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  /* background-color: #3057da; */
  position: fixed;
  left: 50%;
  top: 50%;
  pointer-events: none;
  z-index: 999;
  /* transition: background 0.3s, width 0.3s, height 0.3s; */
}

.mouse::before {
  position: absolute;
  content: '';
  width: 36px;
  height: 36px;
  background: url(./assets/cursor.png) no-repeat center center;
  background-size: contain;
  left: 50%;
  top: 50%;
  margin: -18px 0 0 -18px;
  animation: mouse 3s linear infinite both;
  transition: 0.3s;
}
.mouseact {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  /* background-color: #3057da; */
  position: fixed;
  left: 50%;
  top: 50%;
  pointer-events: none;
  z-index: 999;
  /* transition: background 0.3s, width 0.3s, height 0.3s; */
}
.mouseact::before {
  position: absolute;
  content: '';
  width: 42px;
  height: 42px;
  background: url(./assets/cursor-a.png) no-repeat center center;
  background-size: contain;
  left: 50%;
  top: 50%;
  margin: -18px 0 0 -18px;
  animation: mouse 3s linear infinite both;
  transition: 0.3s;
}

@keyframes mouse {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
@font-face {
  font-family: 'Algerianbasd';
  src: url('./assets/Algerianbasd.ttf');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Munake';
  src: url('./assets/MUNAKE-DEMO.TTF');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'FZYSC';
  src: url('./assets/方正粗雅宋_GBK.TTF');
  font-weight: normal;
  font-style: normal;
}
.font-type {
  font-family: 'Algerianbasd', sans-serif;
}
.font-type2 {
  font-family: 'Munake', sans-serif;
}
.font-type3 {
  font-family: 'FZYSC', sans-serif;
}
</style>
<style>
.toast-success {
  background: rgba(5, 155, 5, 0.9) !important;
}
.toast-fail {
  background: rgba(255 85 102 / 90%) !important;
}
</style>
